module.exports = __webpack_public_path__ + "static/media/marathon.425f64f7.svg";